module.exports = __webpack_public_path__ + "img/vue-mk-header.f24b2888.jpg";